/* eslint-disable */
export const VERSION_CHANGE = 'VERSION_CHANGE';
export const UNREADER_NUM_ONMESSAGE = 'UNREADER_NUM_ONMESSAGE';
